// Handle checkbox fields changes

export const handleChangeFactory = (dispatch) => {
    return e => {
        const isChecked = e.target.checked;
        const {name, value} = e.target;

        if (isChecked) {
            dispatch({ type: "CHANGE_VALUE", name: name, value: value });
        } else {
            dispatch({ type: "REMOVE_VALUE", value: value });
        }
    }
}
